// extracted by mini-css-extract-plugin
export default {"separator":"P8h+wsY9bx9xF5aq9adnZQ=="};